export default __webpack_public_path__ + "static/media/Sass.17390d9e.svg";